import ViaCalamo from '../images/137.jpg'
import PiazzaMarconi from '../images/TAGLIO1.jpg'
import ViaPadula from '../images/TAGLIO12.jpg'

export const StradePiazzeData = [
    {
        title: "VIA CALAMO",
        description: "arteria principale della città di Acri, prende il nome dal fiume che scorre nel sottosuolo. In occasione dell’evento sarà il luogo di ritrovo per i due percorsi da seguire verso la parte antica catturando l’attenzione dei passanti grazie alla realizzazione di murales e all’intrattenimento con spettacoli e laboratori",
        shortDescription: "dalla copert(ur)a del fiume",
        bgc: "linear(to-r, #CBD5E0, #A0AEC0)",
        img: ViaCalamo
    },
    {
        title: "VIA PADULA",
        description: "è la via in cui visse e operò, dopo l’Unità d’Italia, il poeta acrese Vincenzo Padula, noto giornalista e fondatore del periodico Il Bruzio. È una zona suggestiva, oggi sede della Fondazione che ricorda il Poeta, di alcuni uffici, di associazioni e attività commerciali, che percorrendola ci riporta indietro nel tempo alle numerose botteghe di commercianti e artigiani. In occasione dell’evento fungerà da vetrina per fotografi, artisti, musei, imprese e associazioni ma sarà soprattutto luogo di incontri, letture e intrattenimento musicale",
        shortDescription: "alla scoperta di antichi versi",
        bgc: "linear(to-r, #805AD5, #6B46C1)",
        img: ViaPadula,
    },
    {
        title: "PIAZZA MARCONI",
        description: "chiamata e conosciuta meglio come Piazza dei Frutti per via del mercato ortofrutticolo che ospita quotidianamente. L’antica Piazza diede i natali a illustri personaggi come Vincenzo Julia e i Fratelli Scervini. Dalla sua terrazza si può osservare la Torre dell’antico rione Padia mentre il centro è luogo di socializzazione di vecchie e nuove generazioni. Sarà il punto di arrivo del percorso in cui rilassarsi e condividere momenti unici grazie ai racconti del passato e all’intrattenimento musicale",
        shortDescription: "alla parte Vecchia",
        bgc: "linear(to-r, #F6E05E, #ECC94B)",
        img: PiazzaMarconi
    }
]